export const isOnPage = (pageLink, pathname) => pageLink.split('?').shift() === pathname
